import "./style.css";
import back from "./back.svg";
import tel from "./tel.svg";
import { useRef } from "react";
import "../fonts/stylesheet.css";
export default function Header() {
  const copyInputHolder = useRef(null);
  const copiedBox = useRef(null);
  const copyText = () => {
    copyInputHolder.current.select();

    document.execCommand("copy");
    copiedBox.current.style.top = "3vh";
    setTimeout(() => {
      copiedBox.current.style.top = "-15vh";
    }, 2000);
  };
  /* 88002220403 */
  return (
    <div className="headerMain">
      <div
        className="back"
        onClick={() => {
          window.history.back();
        }}
      >
        <img src={back} alt="" />
        <p>Назад</p>
      </div>
      <input
        ref={copyInputHolder}
        value={"+7(495)885-72-57"}
        className="dont_have_mavieID_inviter_name_phone"
        readOnly
        style={{ display: "none" }}
      ></input>
      <div className="tel">
        <p>
          Задать <br /> вопрос
        </p>
        <div onClick={() => copyText()}>
          <img src={tel} alt="" />
          <input
            ref={copyInputHolder}
            value={"+7(495)885-72-57"}
            readOnly
          ></input>
        </div>
      </div>
      <div ref={copiedBox} className="copied_phone">
        Номер телефона <br /> скопирован
      </div>
    </div>
  );
}
